import React, { useState } from "react";
import useSlider from "../../hooks/useSlider";
import Sidebar from "../sidebar/Sidebar";
import { useQuery } from "@tanstack/react-query";
import { toastAlert } from "../../utils/SweetAlert";
import { Copy } from "lucide-react";
import { getSupports } from "../../services/services";

import "./supportTickets.css";

const TicketDetails = () => {
  const isSlider = useSlider();
  const [copiedField, setCopiedField] = useState(null);

  // ✅ Fetch support details
  const { data } = useQuery({
    queryKey: ["support-details"],
    queryFn: async () => {
      const resp = await getSupports();
      return resp?.data?.data; // { email, mobile, dialCode }
    },
  });

  const handleCopy = (field, value) => {
    navigator.clipboard.writeText(value);
    setCopiedField(field);
    toastAlert("success", `${field} copied!`);

    setTimeout(() => setCopiedField(null), 2000);
  };

  const details = [
    { label: "Email", value: data?.email },
    { label: "Phone Number", value: data?.mobile },
    { label: "Dial Code", value: data?.dialCode },
  ];

  return (
    <div className="mainbox">
      <Sidebar />
      <section
        className={isSlider ? "body-content close" : "body-content open"}
      >
        <div className="container-fluid">
          <h2 className="main-heading fontSize24 mb-4">Support Details</h2>

          <div className="support-card p-3">
            {details.map(
              (item) =>
                item.value && (
                  <div
                    key={item.label}
                    className="d-flex justify-content-between align-items-center support-row mb-3"
                  >
                    <div>
                      <h3 className="ticket_detail fontSize14 mb-1">
                        {item.label}
                      </h3>
                      <span className="main-heading fontSize16">
                        {item.value}
                      </span>
                    </div>
                    <Copy
                      className="cursor-pointer text-success"
                      size={20}
                      onClick={() => handleCopy(item.label, item.value)}
                    />
                  </div>
                )
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TicketDetails;
